namespace $ { $mol_style_attach( "raggu/web/front/mark/mark.view.css",
 "[raggu_web_front_mark] {\n\tdisplay: block;\n\tflex: none;\n\twidth: 30px;\n\theight: 30px;\n\tborder-radius: 9px;\n}\n"
) }